import { render, staticRenderFns } from "./PalletsHours.vue?vue&type=template&id=51a564b7&"
import script from "./PalletsHours.vue?vue&type=script&lang=js&"
export * from "./PalletsHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports